<template>
  <div class="top-header">
    <div class="inner-wrap">
      <div class="logo" :class="[logoClass]"></div>

      <div class="header-safe" v-if="isShowSafe">
        <div class="header-safe__icon"></div>
        <p class="header-safe__tip">
          {{ letter.officialStore }} <br />
          {{ letter.headerSafeTip }}
        </p>
      </div>
      <slot name="topHeaderTips"></slot>
      <!-- 2024.12.17 星谕：韩国大掌柜专属规则弹窗按钮-->
      <div
        class="top-header-tips"
        v-if="gameId == 211 && lang == 'ko-KR'"
        @click="show211TipsPopup"
      >
        한정 혜택
      </div>
      <!-- 还没上线代币和钱包的旧入口-开始 -->
      <div
        class="top-header-my-coupon j-click-top-my-coupon"
        v-if="
          isShowTopCoupon &&
          isShowGameCouponEntry &&
          !hasLoadPaytype &&
          !isUidTypeAndHideVipCoupon
        "
        @click="showGameCouponPopup"
      >
        {{ letter.couponMyQuan }}
      </div>
      <div
        class="top-header-vip-score j-click-top-vip-score"
        v-if="
          isShowVipScore &&
          !hasLoadPaytype &&
          isLogin &&
          !isUidTypeAndHideVipCoupon
        "
        @click="handleVipJump"
      >
        {{ vipBtnText }}
      </div>
      <!-- 还没上线代币和钱包的旧入口-结束 -->

      <!-- 上线了代币和钱包的新入口-开始 -->
      <div class="top-header-back-store" v-if="isShowBack" @click="toStorePage">
        {{ '<' + letter.backPay }}
      </div>
      <div
        class="new-pay-welfare"
        v-if="isLogin && showWelfareBtn"
        @click="visibleWelfarePopupHandle(true)"
      >
        <em class="icon"></em>
        <span class="text">{{ letter.payWelfareText }}</span>
        <em class="right-icon"></em>
      </div>
      <div
        class="top-header-my-wallet"
        v-if="isShowWallet && isLogin"
        @click="toWalletPage"
      >
        {{ getCoinsName }}
      </div>
      <!-- 上线了代币和钱包的新入口-结束 -->

      <Select
        v-if="showLangSelector && !specialLangHide"
        icon="selectico"
        rightSpan="53px"
        class="select-wrap"
        pointClass="j-select-lang-ele"
        selectClass="j-select-lang-ele"
        @click="handleLang"
        v-model="lang"
      >
        <template slot="option">
          <option
            v-for="(text, langVal) in langList"
            :key="langVal"
            :value="langVal"
          >
            {{ text }}
          </option>
        </template>
        <template slot="ico">
          <em class="ico"></em>
        </template>
      </Select>
    </div>
    <div class="header-bottom-safe" v-if="isShowSafe">
      <div class="header-bottom-safe__icon"></div>
      <p>{{ letter.officialStore }} {{ letter.headerSafeTip }}</p>
    </div>
    <welfare-popup v-bind:visible.sync="visibleWelfarePopup"></welfare-popup>
    <PopupWindow
      v-if="visibleTipPopup"
      type="tips"
      :languages="letter"
      :autoHeight="true"
      title=" "
      :content="dzgTipContent"
      textAlign="center"
      @onConfirm="visibleTipPopup = false"
      @onCancel="visibleTipPopup = false"
    ></PopupWindow>
  </div>
</template>

<script>
import openActivity, { MAIN_BAR_ACTIVITY } from '@utiles/openActivity';
import globalConfig from '@utiles/officialStore/globalConfig';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import { LANGUAGE_LOCALSTORGE_NAME } from '@store/languages';
import { mapGetters, mapState } from 'vuex';
import {
  SWITCH_LANGUAGE,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES,
  SET_SHOW_CHANNEL_STATUS,
  UPDATE_LOADING,
  CLEAR_PRODUCT_LIST
} from '@store/officialStore';
import { CLEAR_CART, UPDATE_IS_CART } from '@store/officialStore/cart';
import coupon from '@mixins/officialStore/coupon';
import login from '@mixins/officialStore/login';
import showWelfare from '@mixins/officialStore/showWelfare';
import WelfarePopup from './WelfarePopup.vue';
import {
  jumpPnsWithToken,
  NEED_TO_JUMP_PNS_GAMEID
} from '@utiles/jumpWithToken';
import {
  popupType,
  showPopup,
  clickButton
} from '@plugins/biPoint/_configWebstoreV1';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';

export default {
  components: { WelfarePopup },
  mixins: [coupon, login, showWelfare],
  props: {
    showWebsite: {
      default: true
    },
    showLoginBtn: {
      default: true
    },
    showLangSelector: {
      default: true
    },
    isCoins: {
      default: false
    }
  },
  data() {
    return {
      visibleWelfarePopup: false,
      visibleTipPopup: false,
      dzgTipContent:
        '친애하는 사장님, 15% 할인 한정 이벤트가 이미 시작되었습니다. 공식 웹사이트의 충전 페이지에 로그인하여 쿠폰을 받은 후, 【Bank Transfer】결제 방식을 통해 사용하여 할인을 받을 수 있습니다. 쿠폰의 유효기간은 수령 후 30일이니, 이 점 유의해 주시기 바랍니다!'
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.login.isLogin,
      passportToken: state => state.login.passportToken,
      serverId: state => state.serverId,
      roleId: state => state.roleId,
      pcServerId: state => state.pcServerId,
      langList: state => state.langList,
      letter: state => state.letter,
      welfareBtnRecord: state => state.welfareBtnRecord,
      cartList: state => state.cart.cartList
    }),
    ...mapGetters(['gameInfoConfig', 'getCoinsName']),
    isShowBack() {
      if (!gameInfoConfig[+this.gameId].isUpdateNewVersion) {
        return false;
      }
      return ![
        'home',
        'vipScore',
        'bankInfo',
        'result',
        'shareEvent',
        'browserPay'
      ].includes(this.$route.name);
    },
    isShowWallet() {
      //黑五更新逻辑:新版本钱包入口迁移到福利弹窗内,旧版本不显示,江美保留新版本样式
      if (!gameInfoConfig[+this.gameId].isUpdateNewVersion) {
        return false;
      }
      if (!gameInfoConfig[+this.gameId].isShowWallet) {
        return false;
      }
      if (gameInfoConfig[+this.gameId].isBlackFridayVersion) {
        return false;
      }
      return !['coins', 'wallet', 'bankInfo', 'result'].includes(
        this.$route.name
      );
    },
    specialLangHide() {
      // 日本江山美人特殊处理，固定为日语隐藏语言选项
      return +this.gameId == 2;
    },
    lang: {
      get() {
        return this.$store.state.lang;
      },
      set(val) {
        globalConfig.setLclStorageItem(LANGUAGE_LOCALSTORGE_NAME, val);
        // 2024.08.08 邓智轩：需要检查的游戏，且语言为日本时，跳转pns站点
        if (NEED_TO_JUMP_PNS_GAMEID.includes(+this.gameId) && val === 'ja-JP') {
          let targetHref = window.location.href;
          const paramsKey = ['server_id', 'serverId', 'roleId', 'language'];
          const paramsVal = [this.serverId, this.pcServerId, this.roleId, val];
          paramsKey.forEach((key, index) => {
            targetHref = globalConfig.hrefAddParam(
              targetHref,
              key,
              paramsVal[index] || ''
            );
          });
          jumpPnsWithToken(
            this.passportToken,
            getGlobalGetGotoLink({ link: targetHref })
          );
        }
        this.$store.dispatch(SWITCH_LANGUAGE, val);
        window?.globalUpdateCommonParamsInfo?.({
          language: val
        });
        clickButton({
          btnName: 'select_language',
          locationKey: this.$route.meta.pageName
        });
        this.$store.commit(UPDATE_LOADING, false);
        if (this.isCoins) {
          this.$store.commit(UPDATE_PRODUCT_LIST, []);
          this.$store.commit(UPDATE_PRODUCT_TYPES, []);
          this.$store.commit(CLEAR_CART);
          this.$store.commit(UPDATE_IS_CART, false);
        } else {
          this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
          if (this.$store.state.serverId && this.$store.state.roleId) {
            this.$store.dispatch(GET_PRODUCT_LIST);
            this.$store.commit(UPDATE_PRODUCT_LIST, []);
            this.$store.commit(UPDATE_PRODUCT_TYPES, []);
            this.$store.commit(CLEAR_CART);
            this.$store.commit(UPDATE_IS_CART, false);
          }
        }
      }
    },
    logoClass() {
      let gameId = +this.gameId || '';
      const logoHandle = {
        191: 'ztmslgLogoHandle',
        213: 'dzgGLogoHandle',
        211: 'dzgKrLogoHandle',
        209: 'dzgJpLogoHandle',
        215: 'dzgVnLogoHandle'
      };
      if (gameId && logoHandle[gameId]) {
        return this[logoHandle[gameId]]();
      } else {
        return '';
      }
    },
    isShowTopCoupon() {
      if (gameInfoConfig[+this.gameId].isBlackFridayVersion) {
        return false;
      }
      if (gameInfoConfig[this.gameId].isUpdateNewVersion) {
        return false;
      }
      return gameInfoConfig[this.gameId].isHeaderCoupon;
    },
    isShowSafe() {
      return !!gameInfoConfig[this.gameId]?.isShowSafe;
    },
    vipBtnText() {
      if (this.showRightsCenter) {
        return this.letter.vipHead213;
      }
      return this.letter.vipHead;
    }
  },
  methods: {
    handleLang() {
      clickButton({
        btnName: 'select_language_btn',
        locationKey: this.$route.meta.pageName
      });
    },
    handleVipJump() {
      clickButton({
        btnName: 'btn_vip'
      });
      const jumpRightsCenterLink = {
        209: `https://auto-page.${globalConfig.getMainHost()}/vip01/`,
        211: 'https://auto-page.blancozone.com/krdzgvip01/'
      };
      if (+this.gameId && jumpRightsCenterLink[+this.gameId]) {
        openActivity(MAIN_BAR_ACTIVITY, jumpRightsCenterLink[+this.gameId], {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
        return;
      }
      this.$router.push({
        name: 'vipScore',
        locationKey: this.$route.meta.pageName
      });
    },
    visibleWelfarePopupHandle(bool) {
      clickButton({
        btnName: 'btn_events',
        locationKey: this.$route.meta.pageName
      });
      if (bool) {
        showPopup(popupType.eventlistPopup);
      }
      this.visibleWelfarePopup = bool;
    },
    toStorePage() {
      clickButton({
        btnName: 'back_homePage',
        locationKey: this.$route.meta.pageName
      });
      this.$store.dispatch(CLEAR_PRODUCT_LIST);
      if (this.$store.state.serverId && this.$store.state.roleId) {
        this.$store.dispatch(GET_PRODUCT_LIST);
      }
      this.$router.push({ name: 'home' });
    },
    toWalletPage() {
      this.$router.push({ name: 'wallet' });
    },
    isDomain37() {
      return globalConfig.getMainHost() === window.atob('MzdnYW1lcy5jb20=');
    },
    isDomainBlancozone() {
      return globalConfig.getMainHost() === 'blancozone.com';
    },
    isPageLang(lang) {
      return this.lang === lang;
    },
    ztmslgLogoHandle() {
      const LANG = {
        jp: 'ja-JP',
        kr: 'ko-KR',
        tw: 'zh-TW'
      };
      if (this.isDomain37() && this.isPageLang(LANG.jp)) {
        return LANG.jp;
      }

      if (this.isDomainBlancozone() && this.isPageLang(LANG.kr)) {
        return LANG.kr;
      }

      if (this.isDomainBlancozone() && this.isPageLang(LANG.tw)) {
        return LANG.tw;
      }

      return '';
    },
    dzgGLogoHandle() {
      if (this.isPageLang('th-TH')) {
        return 'th-TH';
      }
      return '';
    },
    dzgJpLogoHandle() {
      return 'ja-JP';
    },
    dzgKrLogoHandle() {
      return 'ko-KR';
    },
    dzgVnLogoHandle() {
      return 'vi-VN';
    },
    show211TipsPopup() {
      this.visibleTipPopup = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
.top-header {
  position: fixed;
  top: -1px;
  z-index: 11;
  box-sizing: border-box;
  padding: 0 24px;
  width: 100%;
  background-size: cover;
  font-size: 24px;
  @psetbg ('top-bg.png', false);
  .inner-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  }

  .logo {
    position: absolute;
    left: 32px;
    top: 50%;
    background-size: cover;
    transform: translateY(-50%);
    @psetbg ('logo.png');
  }

  .header-safe {
    display: none;
    position: absolute;
    left: 184px;
    top: 50%;
    transform: translateY(-50%);
    align-items: center;
    justify-content: center;
    min-width: 215px;
    padding: 5px;
    flex-wrap: wrap;
    height: 54px;
    border-radius: 16px;
    background-color: rgba(0, 0, 0, 0.6);
    gap: 10px;
    &__icon {
      width: 36px;
      height: 41px;
      background-size: cover;
      @psetbg ('header-safe-icon.png');
      flex-shrink: 0;
    }
    &__tip {
      text-align: left;
      font-size: 16px;
      color: #fff;
    }
  }
  .header-bottom-safe {
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    border-radius: 0 0 10px 10px;

    &__icon {
      width: 36px;
      height: 41px;
      background-size: cover;
      @psetbg ('header-safe-icon.png');
      flex-shrink: 0;
    }
  }

  .select-wrap {
    display: inline-block;
    position: relative;
    cursor: pointer;
    color: var(--header-lang) !important;
    &:hover {
      color: #fff;
    }
    ::v-deep .select {
      padding: 0 12px;
    }
  }
  .top-header-back-store,
  .top-header-pay-welfare,
  .top-header-my-wallet {
    line-height: 44px;
    @psetbg ('header-wallet-bg.png');
  }
  .new-pay-welfare {
    cursor: pointer;
    background-size: cover;
    @psetbg ('pay-welfare-btn-bg.png');
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 30px;
    min-width: 165px;
    width: fit-content !important;
    background-position: center;
    border-radius: 20.5px;

    .icon {
      display: inline-block;
      width: 58px;
      height: 59px;
      margin-top: -10px;
      margin-left: -28px;
      margin-right: 5px;
      vertical-align: middle;
      @psetbg ('pay-welfare-btn-icon.png');
      animation: shake 2s ease-in-out 0.5s infinite;
    }
    .right-icon {
      display: inline-block;
      width: 9px;
      height: 10px;
      margin-right: 17px;
      margin: 0 17px 0 7px;
      vertical-align: middle;
      @psetbg ('pay-welfare-right-icon.png');
    }

    .text {
      font-family: SourceHanSansSC-Medium;
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      background-image: -webkit-linear-gradient(top, #faebbd 50%, #f9bd7e 50%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .top-header-tips,
  .top-header-back-store,
  .top-header-my-coupon,
  .top-header-vip-score,
  .top-header-pay-welfare,
  .top-header-my-wallet {
    margin: 0 8px;
    cursor: pointer;
    font-size: 24px;
    color: var(--header-coupon-entry);
  }
  .ico {
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    @psetbg ('lang-ico.png');
  }
  .top-header-pay-welfare {
    position: relative;
    &::after {
      display: none;
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      width: 16px;
      height: 16px;
      background-color: #ff2800;
      border-radius: 50%;
    }

    &.active::after {
      display: block;
    }
  }
}

@media screen and (orientation: landscape) {
  .top-header {
    padding: 0;
    background-size: cover;
    @psetbg ('top-bg-hen.png', false);
    .inner-wrap {
      position: relative;
      margin: 0 auto;
      width: 1202px;
    }

    .logo {
      // 这里
      position: absolute;
      left: 0;
      @psetbg ('logo-hen.png');
    }

    .header-safe {
      display: flex;
    }

    .header-bottom-safe {
      display: none;
    }
  }
}

@keyframes shake {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    transform: translateY(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateY(-5px);
  }
}
</style>
